import { render, staticRenderFns } from "./List.vue?vue&type=template&id=07119fa3&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/figma.css?vue&type=style&index=0&id=07119fa3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07119fa3",
  null
  
)

export default component.exports